import script from "./CommonCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./CommonCellElementLite.vue?vue&type=style&index=0&id=84ffbb14&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84ffbb14"]])

export default __exports__